// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"354":"a1524be7","418":"b030d511","668":"c37e30d7"}[chunkId] + ".js";
};